import React from 'react';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';

import { RadioButtonGroup, DatePicker } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import * as formatter from 'helpers/Formatter';
import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';

const validate = values => {
  const errors = {};
  if (!values.lease_break) errors.lease_break = 'Required';
  if (!values.move_out_date) errors.move_out_date = 'Required';
  return errors;
};

let MoveOutCreatorWizardPage = props => {
  const { handleSubmit, showLastBillableDay, displayLastBillableDay, hideLastBillableDay } = props;

  const renderError = ({ meta: { touched, error } }) =>
    touched && error ? (
      <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
    ) : (
      false
    );

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="row" style={{ marginTop: '0' }}>
          <div className="col-xs-3" />
          <div className="col-xs-6" style={{ marginTop: '0px', textAlign: 'center' }}>
            <Field
              name="move_out_date"
              component={DatePicker}
              openToYearSelection={true}
              style={{ marginTop: '-15px', fontSize: '14px' }}
              formatDate={formatter.reformatDate}
              validate={[validator.required]}
              autoOk={true}
              textFieldStyle={{ fontSize: '14px', width: '100%' }}
              floatingLabelText="Move Out Date"
            />
          </div>
          <div style={{ textAlign: 'center', margin: '70px 0 10px' }}>
            <div style={{ fontSize: '14px' }}>
              Will the <TenantResidentVerbiageHelper /> be breaking the lease?
            </div>
          </div>
          <div className="col-xs-12" style={{ textAlign: 'center', marginTop: '0px' }}>
            <Field
              name="lease_break"
              component={RadioButtonGroup}
              onChange={(event, value) => {
                if (value === 'Yes') {
                  displayLastBillableDay();
                } else {
                  hideLastBillableDay();
                }
              }}
              style={{ width: '187px', margin: 'auto' }}
            >
              <RadioButton
                value="Yes"
                label="Yes"
                style={{ width: '102px', display: 'inline-flex' }}
              />
              <RadioButton
                value="No"
                label="No"
                style={{
                  width: '70px',
                  display: 'inline-flex',
                  float: 'right',
                }}
              />
            </Field>
            <Field name="lease_break" component={renderError} />
          </div>
        </div>
        {showLastBillableDay && (
          <div className="row" style={{ marginTop: '0px' }}>
            <div className="col-xs-3" />
            <div className="col-xs-6" style={{ textAlign: 'center' }}>
              <Field
                name="last_billable_day"
                component={DatePicker}
                openToYearSelection={true}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                formatDate={formatter.reformatDate}
                validate={[validator.required]}
                autoOk={true}
                textFieldStyle={{ fontSize: '14px', width: '100%' }}
                floatingLabelText="Last Billable Day"
              />
              <Field name="last_billable_day" component={renderError} />
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default compose(
  reduxForm({
    form: 'move_out_creator_form',
    forceUnregisterOnUnmount: true,
    destroyOnUnmount: true,
    validate,
  })
)(MoveOutCreatorWizardPage);
